module.exports = __webpack_public_path__ + "static/media/evenflo_stroller_2.e6bb4902.jpg";